export enum TicketStatusEnum {
    SOLD_OUT,
    AVAILABLE,
    NO_AVAILABLE
}